module.exports = __webpack_public_path__ + "static/media/Portrait-10035.c6afb6d1.jpg";